import React from 'react';
import classnames from 'classnames';
import './index.scss';

type TableHeaderProps = {
  className?: string;
  title: string;
  subtitle?: React.ReactNode;
};

const TableHeader = (props: TableHeaderProps) => {
  const { className, title, subtitle } = props;

  return (
    <div className={classnames('dbo-compare-key-metrics-header', className)}>
      <span className={'title'}>{title}</span>
      {subtitle && <span className={'subtitle'}>{subtitle}</span>}
    </div>
  );
};

export default TableHeader;
